import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { SessionService } from '@monsido/ng2/core/session/session.service';
import { User, UserUpdateRequest, UserCreateRequest } from '@client/app/feature-modules/admin/modules/admin-users/types/user.type';
import { CollectionInterface } from '@monsido/angular-shared-components';
import { RequestParamsType } from '@monsido/ng2/external/http/options';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import { HttpContextToken } from '@angular/common/http';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';

export type UserRepoRequestType = RequestParamsType & BaseRepoRequestType;
@Injectable({
    providedIn: 'root',
})
export class UserRepoService extends BaseRepo {
    constructor (private apiService: ApiService, protected sessionService: SessionService) {
        super();
    }

    get (id: string, params: UserRepoRequestType = {}, contextToken?: HttpContextToken<unknown>): Promise<User> {
        return this.apiService.get<User>('users/' + id, params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    getAll (params: UserRepoRequestType = {}): Promise<CollectionInterface<User>> {
        return this.apiService.get<CollectionInterface<User>>('users', params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    create (params: UserCreateRequest): Promise<User | void> {
        return this.apiService.post<User>('users', params, contextTokens.NO_GLOBAL);
    }

    // Accept both our typed UserUpdateRequest and legacy UserRepoRequestType
    update (params: Partial<UserUpdateRequest>): Promise<User> {
        return this.apiService.patch<User>('users/' + params.id, params, undefined, contextTokens.NO_GLOBAL);
    }

    delete (user: Pick<User, 'id'>): Promise<void> {
        return this.apiService.delete('users/' + user.id, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
